import React from 'react';
import { Link } from 'react-router-dom';
import { Wand2, ArrowRight } from 'lucide-react';

const VisualizerBanner = () => (
  <section className="py-10 bg-white" data-testid="visualizer-banner">
    <div className="max-w-7xl mx-auto px-4">
      <Link to="/renovatie-ontwerpen" className="group flex flex-col md:flex-row md:items-center gap-5 rounded-2xl bg-[#3a190b] text-white p-6 md:p-8 hover:bg-[#500000] transition-colors">
        <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0"><Wand2 className="h-6 w-6" /></div>
        <div className="flex-1">
          <p className="text-xs uppercase tracking-[0.2em] text-white/60 mb-1">Nieuw · gratis</p>
          <h2 className="text-xl md:text-2xl font-bold">Zie uw gerenoveerde ruimte vóór u beslist</h2>
          <p className="text-white/75 text-sm mt-1">Upload een foto van uw badkamer, keuken, woonkamer of zolder, typ wat u wil — onze AI toont in 1 minuut een fotorealistisch ontwerp van úw ruimte.</p>
        </div>
        <span className="inline-flex items-center gap-2 bg-white text-[#3a190b] px-5 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap">Probeer gratis<ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
      </Link>
    </div>
  </section>
);

export default VisualizerBanner;
